<div class="box-footer">
  <ng-content></ng-content>
</div>
